import { z } from 'zod';

export const CreateBillSchema = z.object({
  name: z.string().min(1, 'Bill name is required'),
  displayName: z.string().min(1, 'Display name is required').optional(),
  source: z.enum(['manual', 'scan']).optional(),
  categoryId: z.string().uuid().optional(),
  amount: z.number().positive('Amount must be greater than zero'),
  frequency: z.enum(['weekly', 'fortnightly', 'monthly', 'quarterly', 'yearly', 'one_off']),
  dueDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  dayOfMonth: z.number().int().min(1).max(31).optional(),
  autopay: z.boolean().optional(),
});

export function validateCreateBill(input: unknown) {
  return CreateBillSchema.safeParse(input);
}
